import { render, staticRenderFns } from "./BuyerEditCampaign.vue?vue&type=template&id=75ed8db4&scoped=true"
import script from "./BuyerEditCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerEditCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed8db4",
  null
  
)

export default component.exports